import React from 'react';
import MenuItem from 'components/base/secure/header/menu-item';

const Navbar = (props) => (
    <ul>
        <MenuItem name="Budget" to="/" />
        <MenuItem name="CATEGORIES" to="/categories" />
        {/*<MenuItem name="Menu">
            <MenuItem name="Sub link" to="/" />
            <MenuItem name="Sub link" to="/" />
            <MenuItem name="Sub link" to="/" />
        </MenuItem>*/}
    </ul>
);

export default Navbar;


// WEBPACK FOOTER //
// ./src/components/base/secure/header/navbar.js